<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner
            :animation-duration="2000"
            :size="80"
            color="#63c2de"
            class="offset-6"
          >Entrar</semipolar-spinner>
        </div>
        <table-campaign
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-table mr-2'></i> Campañas</h4>"
          v-else
        ></table-campaign>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableCampaign from "./TableCampaign.vue";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

export default {
  name: "tables",
  components: { TableCampaign, SemipolarSpinner },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre de campaña", sortable: true },
        //{ key: "objective", label: "Objetivo", sortable: true },
        { key: "status", label: "Estado", sortable: true },
        {key:"objective_id",label:"Objetivo",sortable: true},
        {key:"acciones",label:"Acciones"}
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getCampaigns();
  },
  methods: {
    getCampaigns() {
      var campaigns = store.getters.getCampaigns;
      if (campaigns.length == 0) {
        this.isLoading = true;
        store.dispatch("getCampaigns").then(() => {
          var campaigns = store.getters.getCampaigns;
          shuffleArray([campaigns]);
          this.isLoading = false;
          this.items = campaigns;
          this.itemsArray = campaigns;
        });
      } else {
        shuffleArray([campaigns]);
        this.items = campaigns;
        this.itemsArray = campaigns;
      }
    }
  }
};
</script>
